<script lang="ts" setup>
import { computed } from "vue";
import { useDocumentPip } from "@/composables";

const showWindow = defineModel<boolean>({ default: false });

const props = withDefaults(
  defineProps<{
    width?: number;
    height?: number;
  }>(),
  {
    width: 1200,
    height: 800,
  },
);

const { pipContainer } = useDocumentPip({
  width: props.width,
  height: props.height,
  onClose: () => {
    showWindow.value = false;
  },
});

const overlayDefaults = computed(() => ({
  global: { attach: pipContainer.value ?? undefined },
}));
</script>

<template>
  <teleport v-if="pipContainer" :to="pipContainer">
    <v-defaults-provider :defaults="overlayDefaults">
      <div class="pip-layout bg-white d-flex flex-column">
        <slot />
      </div>
    </v-defaults-provider>
  </teleport>
</template>

<style lang="scss">
.pip-layout {
  height: 100vh;
  overflow: hidden;
}
</style>
